module.exports = __webpack_public_path__ + "media/images/logo/vk_b-98e265654eb86e30c3ec289f65995801.svg";